module.exports = __webpack_public_path__ + "static/img/video_ranking_list_top1.b5d7c24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_ranking_list_top1.png
// module id = pt4X
// module chunks = 1